import { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

export function ShortcutTooltip({
  keyboardKey,
  children,
}: {
  keyboardKey: string;
  children?: ReactNode;
}) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent>
          <p>Alt + {keyboardKey}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
